export default __webpack_public_path__ + "static/media/curseur.213b5539.png";